import { useMediaQuery } from "@mui/material";
import { ReactComponent as WaymoreLogo } from "../../assets/waymore.svg";

import {
  HeaderActionButtonsContainer,
  HeaderAvatarContainer,
  HeaderImageContainer,
  HeaderInnerGrid,
  HeaderLogoActionsContainer,
  HeaderLogoTextContainer,
  HeaderTitleContainer,
  HeadingText,
  PreviewHeaderContainer,
} from "./styled";

export default function PreviewHeader({ ModeHeading }: { ModeHeading: string }) {
  const isLessThan1500 = useMediaQuery("(max-width:1500px)");

  return (
    <PreviewHeaderContainer>
      <HeaderInnerGrid container>
        <HeaderLogoActionsContainer item xs={4}>
          <HeaderLogoTextContainer>
            <HeaderImageContainer>
              <WaymoreLogo />
            </HeaderImageContainer>
            {!isLessThan1500 && (
              <HeadingText>Conversational Form Builder</HeadingText>
            )}
          </HeaderLogoTextContainer>
        </HeaderLogoActionsContainer>
        <HeaderTitleContainer item xs={4}>
          <HeadingText>{ModeHeading}</HeadingText>
        </HeaderTitleContainer>
        <HeaderActionButtonsContainer item xs={4}>
          <HeaderAvatarContainer src="/broken-image.jpg" />
        </HeaderActionButtonsContainer>
      </HeaderInnerGrid>
    </PreviewHeaderContainer>
  );
}
